var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isGoogleLoaded)?_c('gmap-map',{staticClass:"map search-result-preview__gmap-map",attrs:{"center":_vm.map.center,"zoom":_vm.map.zoom,"options":_vm.map.options}},[_c('gmap-marker',{attrs:{"position":_vm.map.center,"icon":{
      url: _vm.markerIconUrl,
      scaledSize: {width: 32, height: 32}
    }}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }